import React from 'react';

export default function NubbiSMPage() {
  return (
    <div style={{ padding: '2rem', backgroundColor: '#E6FFE6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.8rem', fontWeight: 'bold', color: '#006400', marginBottom: '1rem' }}>
          📈 Nubbi SM 💰
        </h1>
        <p style={{ fontSize: '1.3rem', lineHeight: '1.8', color: '#333' }}>
          Welcome to <strong>Nubbi SM</strong>, the world’s first character-based stock market.
          Here, creators list their Nubbis with a starting price, and fans or investors can buy shares using Monix.
        </p>

        <div style={{ marginTop: '2rem', backgroundColor: '#ffffff', borderRadius: '16px', padding: '2rem', boxShadow: '0 0 15px rgba(0,0,0,0.1)' }}>
          <h2 style={{ color: '#222', fontSize: '1.5rem', marginBottom: '1rem' }}>🚧 This feature is under construction</h2>
          <p style={{ fontSize: '1.1rem', color: '#666' }}>
            Soon you'll be able to explore trending Nubbis, buy shares with Monix, and even acquire full ownership of characters.
            For now, stay tuned and keep an eye on Nubbi’s evolution...
          </p>
        </div>

        <div style={{ marginTop: '3rem', fontStyle: 'italic', color: '#777' }}>
          Powered by <strong>Monix</strong> — the currency of imagination.
        </div>
      </div>
    </div>
  );
}